export { buildLocations, buildAgencies, buildContacts } from './build-options';
export { default as suggestLocations } from './fetch-suggestions';
export {
  getRecentSearches,
  saveRecentSearches,
  toRecentSearchOption,
  getSafeStorage,
  RECENT_SEARCHES_KEY,
  MAX_RECENT_SEARCHES,
} from './recent-searches';
